import {Main} from "./components/Main/Main.jsx"
import './App.css';

function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
